export enum PaymentPlanType {
    ONE_TIME = "one-time",
    MONTHLY = "month",
    YEARLY = "year",
}